module.exports = __webpack_public_path__ + "img/footer-blue-square.872f8592.svg";